import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './personallferrari_fisioculturismo.module.scss';

const GALLERY_ITEMS: { src: string; label: string }[] = [
    { src: require('./src/fisioculturismo/fisioculturismo1.png'), label: 'Palco 1' },
    { src: require('./src/fisioculturismo/fisioculturismo2.png'), label: 'Palco 2' },
    { src: require('./src/fisioculturismo/fisioculturismo3.png'), label: 'Palco 3' },
    { src: require('./src/fisioculturismo/fisioculturismo4.png'), label: 'Palco 4' },
    { src: require('./src/fisioculturismo/fisioculturismo5.png'), label: 'Palco 5' },
    { src: require('./src/fisioculturismo/fisioculturismo6.png'), label: 'Palco 6' },
    { src: require('./src/fisioculturismo/fisioculturismo7.png'), label: 'Palco 7' },
];

const Personallferrari_fisioculturismo: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.personallferrari_fisioculturismo}>
            <div className={styles.page}>
                <div className={styles.header}>
                    <Link
                        to="/personallferrari"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao cartão digital"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Personal Ferrari</p>
                        <h1 className={styles.title}>Minha trajetória no fisiculturismo</h1>
                    </div>
                </div>

                <div className={styles.story}>
                    <p className={styles.storyLead}>Trajetória competitiva</p>
                    <p className={styles.storyParagraph}>
                        Minha trajetória no fisiculturismo começou em 2016, na categoria Men’s Physique — uma porta de
                        entrada que rapidamente se transformou em paixão e propósito. Foi ali que dei meus primeiros
                        passos competitivos, conquistei títulos e entendi que o esporte ia muito além da estética: era
                        sobre disciplina, constância e evolução.
                    </p>
                    <p className={styles.storyParagraph}>
                        Com o tempo, meu físico e minha mentalidade me levaram à categoria Classic Physique, onde vivi
                        uma das fases mais marcantes da minha carreira, acumulando conquistas e reafirmando meu
                        compromisso com a excelência.
                    </p>
                    <p className={styles.storyParagraph}>
                        Essa evolução natural me conduziu à categoria Bodybuilder até 102kg, onde sigo competindo em alto
                        nível, colecionando grandes colocações e títulos importantes. Cada preparação, cada desafio e
                        cada vitória reforçam a certeza de que estou no caminho certo.
                    </p>
                    <p className={styles.storyParagraph}>
                        Mais do que troféus, o fisiculturismo sempre foi movido por algo maior: o amor pelo processo. A
                        paixão por testar limites, construir um físico de alto nível e vivenciar, na prática, o quanto o
                        corpo humano é capaz de evoluir quando existe estratégia, consistência e dedicação.
                    </p>
                    <p className={styles.storyParagraph}>
                        Essa é a essência que carrego comigo — dentro e fora dos palcos.
                    </p>
                </div>

                <h2 className={styles.galleryTitle}>Nos palcos</h2>
                <div className={styles.grid}>
                    {GALLERY_ITEMS.map((item, index) => (
                        <figure key={item.src} className={styles.card}>
                            <img
                                src={item.src}
                                alt={`Fisiculturismo — ${item.label}`}
                                className={styles.cardImage}
                                loading={index < 2 ? 'eager' : 'lazy'}
                            />
                            <figcaption className={styles.cardFigcaption}>{item.label}</figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Personallferrari_fisioculturismo;
